import { c as _c } from "react/compiler-runtime";
import { SectionHeadline } from '@/components/SectionHeadline';
import { DownloadButton } from '@/components/buttons';
import { Text } from '@/components/typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
function Downloads() {
  const $ = _c(30);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["forJournalists"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] !== t) {
    t1 = t("downloadsSection.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="pb-4 lg:pb-5" anchorKey="downloadsSection.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("downloadsSection.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-16">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("downloadsSection.button.logos");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <DownloadButton to="/images/sections/forJournalists/downloads/cs/Skippay_Logo.zip" testId="downloadsSectionLogos" analyticsParam="downloadsSectionLogos">{t5}</DownloadButton>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("downloadsSection.button.illustrations");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <DownloadButton to="/images/sections/forJournalists/downloads/cs/Skippay_Ilustracni_fotografie.zip" testId="downloadsSectionIllustrations" analyticsParam="downloadsSectionIllustrations">{t7}</DownloadButton>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isCsLanguage || $[18] !== t) {
    t9 = isCsLanguage && <DownloadButton to="/images/sections/forJournalists/downloads/cs/Skippay_Infografika.zip" testId="downloadsSectionInfographic" analyticsParam="downloadsSectionInfographic">{t("downloadsSection.button.infographic")}</DownloadButton>;
    $[17] = isCsLanguage;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="mx-auto flex max-w-sm flex-col gap-2">{t6}{t8}{t9}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t4) {
    t11 = <div className="px-4">{t4}{t10}</div>;
    $[24] = t10;
    $[25] = t4;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t2) {
    t12 = <div className="bg-blue-100 py-14 lg:pt-20 lg:pb-40">{t2}{t11}</div>;
    $[27] = t11;
    $[28] = t2;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
export default Downloads;